window.initPriceBracketFilters = function() {
  const grid = document.getElementById('product-grid');
  if (!grid) return;
 

   const params = new URLSearchParams(window.location.search);
    params.delete('filter.v.price.gte');
    params.delete('filter.v.price.lte');
    params.set('section_id', 'price-range-counts');


fetch(`${window.location.pathname}?${params.toString()}`)
    .then((res) => res.text())
    .then((text) => {
      try {
        return JSON.parse(text);
      } catch (err) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return JSON.parse(doc.body.textContent);
      }
    })
    .then((data) => {
      document.querySelectorAll('.price-bracket-checkbox').forEach((checkbox) => {
        const key = `${checkbox.dataset.min}-${checkbox.dataset.max}`;
        const count = data[key] || 0;

        const span = checkbox.parentElement.querySelector('.count');
        if (span) span.textContent = count;
        checkbox.disabled = count === 0;
      });
    })
    .catch((e) => console.error('Price bracket fetch error', e));
};

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.initPriceBracketFilters === 'function') {
    window.initPriceBracketFilters();
  }
});